<script>
import {articleHeader} from '@/helpers'

export default {
  methods: {
    articleHeader (article, attr = 'title') {
      return articleHeader(article, attr)
    },
  },
}
</script>
